<div class="bundle-product">
  <div class="bundle-product__main">
    <div class="bundle-product__image">
      <img [src]="image.src" alt="{{ image.alt || '' }}" />
    </div>
    <div class="bundle-product__form-container">
      <div class="bundle-product__info">
        <div class="bundle-product__name">{{ product.name }}</div>
      </div>
      <app-yso-product-form
        #productForm
        [product]="product"
        [specificationMap]="bundleItemSpecificationMap"
        [variantsInput]="bundleItemVariants"
        [showQuantity]="false"
        [isBundle]="true"
        (formReady)="onFormReady()"
        class="bundle-product__form"></app-yso-product-form>
      @if (hasBundleDescription) {
        <div class="bundle-product__actions">
          <se-fe-button
            seFeDataEmphasis="low"
            class="bundle-product__details-toggle"
            (click)="onToggleDetails()">
            {{ isExpanded ? 'Hide details' : 'View details' }}
            <se-fe-icon
              [seFeDataName]="isExpanded ? 'chevron_up' : 'chevron_down'"
              seFeDataSize="small"></se-fe-icon>
          </se-fe-button>
        </div>

        <div
          class="bundle-product__description"
          [innerHTML]="productDescription"></div>
      }
    </div>
  </div>
</div>
